import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { highlightGroups, highlightTabs } from '@/mocks/content';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function HighlightsSection() {
  const [active, setActive] = useState('emotion');
  const group = highlightGroups.find((g) => g.key === active) ?? highlightGroups[0];

  return (
    <section id="highlights" className="scroll-mt-16 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Highlights"
            title="主题与看点"
            desc="同一部作品可以从不同角度欣赏。切换下方标签，可以看到情感线、人物塑造、叙事节奏与氛围质感四个方面的具体看点。"
            align="center"
          />
        </Reveal>

        <Reveal delay={60}>
          <div className="mt-8 flex justify-center">
            <div className="flex flex-wrap justify-center gap-1 p-1 rounded-full bg-background-100 border border-background-200">
              {highlightTabs.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setActive(tab.key)}
                  className={`px-4 md:px-5 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    active === tab.key
                      ? 'bg-accent-500 text-background-50'
                      : 'text-foreground-600 hover:text-accent-700'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
          {group.items.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 flex flex-col gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xl">
                  <i className={item.icon} />
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900">{item.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}